import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const QUESTIONS = [
  { q: 'faq.q1', a: 'faq.a1' },
  { q: 'faq.q2', a: 'faq.a2' },
  { q: 'faq.q3', a: 'faq.a3' },
  { q: 'faq.q4', a: 'faq.a4' },
  { q: 'faq.q5', a: 'faq.a5' },
  { q: 'faq.q6', a: 'faq.a6' },
  { q: 'faq.q7', a: 'faq.a7' },
];

export default function FAQSection() {
  const { t } = useTranslation();
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="bg-background-100 py-20 md:py-28">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <div className="reveal mx-auto text-center">
          <span className="mb-5 inline-block h-px w-12 bg-primary-500"></span>
          <h2 className="font-heading text-3xl leading-tight text-foreground-950 md:text-4xl lg:text-5xl">
            {t('faq.title')}
          </h2>
        </div>

        <div className="reveal reveal-delay-1 mt-12 flex flex-col gap-3">
          {QUESTIONS.map((item, index) => {
            const isOpen = open === index;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : index)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-start cursor-pointer"
                >
                  <span className="text-base font-semibold text-foreground-950 md:text-lg">
                    {t(item.q)}
                  </span>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                      isOpen ? 'bg-primary-500 text-foreground-950' : 'bg-background-100 text-foreground-600'
                    }`}
                  >
                    <i
                      className={`text-base transition-transform ${isOpen ? 'ri-subtract-line' : 'ri-add-line'}`}
                      aria-hidden="true"
                    ></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-6 pb-6">
                    <p className="text-sm leading-relaxed text-foreground-600 md:text-base">
                      {t(item.a)}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}